import React, { useEffect, useState } from 'react';
import { getConfig } from '../../utils/config';
import Select from 'react-select';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';
import { useInput, usePhoneInput } from '../../Hooks';
import PhoneInput from 'react-phone-input-2';
import StepOne from './Components/StepOne';
import StepTwo from './Components/StepTwo';
import { num } from '../../constants';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { winnreAuth } from '../../utils/axios';
import { LoadingSpinner } from '../../Components/Molecules/LoadingUI';
import StepThree from './Components/StepThree';

const DealEnquiry = ({ dealRedemptionId, prefilledData }) => {
    const theme = useTheme();
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [unitConfig, setUnitConfig] = useState({});
    const [possessionDuration, setPossessionDuration] = useState(null);
    const [moveInDuration, setMoveInDuration] = useState(null);
    const [comment, setComment] = useState(null);
    const [possessionDate, setPossessionDate] = useState(null);
    const [moveInDate, setMoveInDate] = useState(null);
    
    const prefilledUnitConfig =prefilledData[0]?.unitConfiguration ? prefilledData[0]?.unitConfiguration : '' ;
    const prefilledUnitArea = prefilledData[0]?.unitArea ? prefilledData[0]?.unitArea : '';
    const [unitArea, setUnitArea] = useState(prefilledUnitArea ? prefilledUnitArea : '');
    const [error, setError] = useState('');

    const {
        state: {
            isValid: mobileNumberIsValid,
            mobile,
            country,
            mobileHasError,
            isInputFocused
        },
        onChange,
        validator,
        setMobile,
        setIsTouched,
        getMobileWithoutCountryCode,
        setInputFocused
    } = usePhoneInput();

    

    

    const handleChange = (e) => {
        const Value = e.target.value;
        if (!isNaN(Value)) {
            console.log("it is a number")
            setUnitArea(Value);
            setError('');
        } else {
            setError('Please enter a valid number');
        }
    };

    
    const calculatePlannedDate = (duration) => {
        const currentDateObj = new Date();
        let plannedDate = new Date(currentDateObj);

        if (duration.includes('Days')) {
            const daysLimit = parseInt(duration.split('-')[1]);
            plannedDate.setDate(plannedDate.getDate() + daysLimit);
        } else if (duration.includes('Months')) {
            if (duration.includes('More than 6 Months')) {
                plannedDate.setMonth(plannedDate.getMonth() + 7);
            } else {
                const monthsLimit = parseInt(duration.split('-')[1]);
                plannedDate.setMonth(plannedDate.getMonth() + monthsLimit);
            }
        }

        return plannedDate.toISOString().slice(0, 10);
    };

    useEffect(() => {
        if (possessionDuration !== null) {
            setPossessionDate(calculatePlannedDate(possessionDuration));
        }
    }, [possessionDuration]);

    useEffect(() => {
        if (moveInDuration !== null) {
            setMoveInDate(calculatePlannedDate(moveInDuration));
        }
    }, [moveInDuration]);

    const handleunitConfigChange = (val) => {
        setUnitConfig({
            Name: val.value,
            displayName: val.label
        });
    };
    console.log(
        'unit Config and prefilledUnitConfig and unitArea',
        unitConfig.Name,
        prefilledUnitConfig,
        unitArea
        
    );
    const handleFormSubmit = () => {
        setLoading(true);
        let unitConfiguration = '';
        if (prefilledUnitConfig || (prefilledData.length > 1 && !unitConfig.Name)) {
            unitConfiguration = prefilledUnitConfig;
        } else if (unitConfig.Name) {
            unitConfiguration = unitConfig.Name;
        }
        
        let data = {
            alternatePhoneNumber: mobile,
            comments: comment,
            plannedMoveInDate: moveInDate,
            possessionDate: possessionDate,
            unitArea: unitArea,
           
             unitConfiguration:unitConfiguration

        };
        let url = `winnre/user/deals/consultation-deal-additional-details?dealRedemptionId=${dealRedemptionId}`;

        winnreAuth({
            method: 'POST',
            url,
            headers: { 'Content-Type': 'application/json;charset=utf-8' },
            data: JSON.stringify(data)
        })
            .then((res) => {
                setLoading(false);
                console.log('deal enquiry', res);
                if (
                    res?.status === 'INVALID_TOKEN' ||
                    res?.status === 'FAILED'
                ) {
                    toast.error('Something Went Wrong');
                    return;
                }
                setStep(step + 1);
                window?.webengage?.track('OfferDetailsSubmitted', {
                    alternatePhoneNumber: `${mobile} `,
                    comments: `${comment}`,
                    plannedMoveInDate: `${moveInDate}`,
                    possessionDate: `${possessionDate}`,
                    unitArea: `${unitArea}`,
                    unitConfiguration: `${unitConfiguration}`
                });
            })
            .catch(() => {
                toast.error('Something Went Wrong');
            });
    };

    const getConditionalFormSteps = () => {
        switch (step) {
            case 1:
                return (
                    <StepOne
                        setStep={setStep}
                        unitConfig={unitConfig}
                        handleunitConfigChange={handleunitConfigChange}
                        prefilledData={prefilledData}
                        prefilledUnitConfig={prefilledUnitConfig}
                        prefilledUnitArea={prefilledUnitArea}
                        handleChange ={handleChange}
                        unitArea={unitArea}
                        error={error}
                    />
                );
            case 2:
                return (
                    <StepTwo
                        setStep={setStep}
                        possessionDuration={possessionDuration}
                        setPossessionDuration={setPossessionDuration}
                        moveInDuration={moveInDuration}
                        setMoveInDuration={setMoveInDuration}
                        mobile={mobile}
                        onChange={onChange}
                        validator={validator}
                        setIsTouched={setIsTouched}
                        setInputFocused={setInputFocused}
                        mobileHasError={mobileHasError}
                        comment={comment}
                        setComment={setComment}
                        isInputFocused={isInputFocused}
                        mobileNumberIsValid={mobileNumberIsValid}
                        onFormSubmit={handleFormSubmit}
                        prefilledData={prefilledData}
                    />
                );

            case 3:
                return <StepThree />;

            default:
                <></>;
        }
    };

    return (
        <div>
            <div className=" bg-white flex items-center justify-center p-2 ">
                <div className="">
                    {loading && <LoadingSpinner />}
                    {!loading && getConditionalFormSteps()}
                </div>
            </div>
        </div>
    );
};

export default DealEnquiry;
